'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncIterator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var _asyncGeneratorDelegate = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncGeneratorDelegate");

var _awaitAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var dirBuilder = require('./dir');

var fileBuilder = require('./file');

var errCode = require('err-code');
/**
 * @typedef {import('../types').File} File
 * @typedef {import('../types').Directory} Directory
 * @typedef {import('../types').DAGBuilder} DAGBuilder
 * @typedef {import('../types').Chunker} Chunker
 * @typedef {import('../types').ChunkValidator} ChunkValidator
 */

/**
 * @param {any} thing
 * @returns {thing is Iterable<any>}
 */


function isIterable(thing) {
  return Symbol.iterator in thing;
}
/**
 * @param {any} thing
 * @returns {thing is AsyncIterable<any>}
 */


function isAsyncIterable(thing) {
  return Symbol.asyncIterator in thing;
}
/**
 * @param {Uint8Array | AsyncIterable<Uint8Array> | Iterable<Uint8Array>} content
 * @returns {AsyncIterable<Uint8Array>}
 */


function contentAsAsyncIterable(content) {
  try {
    if (content instanceof Uint8Array) {
      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return content;

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    } else if (isIterable(content)) {
      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.delegateYield(_asyncGeneratorDelegate(_asyncIterator(content), _awaitAsyncGenerator), "t0", 1);

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    } else if (isAsyncIterable(content)) {
      return content;
    }
  } catch (_unused) {
    throw errCode(new Error('Content was invalid'), 'ERR_INVALID_CONTENT');
  }

  throw errCode(new Error('Content was invalid'), 'ERR_INVALID_CONTENT');
}
/**
 * @type {DAGBuilder}
 */


function dagBuilder(_x, _x2, _x3) {
  return _dagBuilder.apply(this, arguments);
}

function _dagBuilder() {
  _dagBuilder = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(source, block, options) {
    var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, entry;

    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _iteratorAbruptCompletion = false;
            _didIteratorError = false;
            _context5.prev = 2;
            _iterator = _asyncIterator(source);

          case 4:
            _context5.next = 6;
            return _awaitAsyncGenerator(_iterator.next());

          case 6:
            if (!(_iteratorAbruptCompletion = !(_step = _context5.sent).done)) {
              _context5.next = 21;
              break;
            }

            entry = _step.value;

            if (entry.path) {
              if (entry.path.substring(0, 2) === './') {
                options.wrapWithDirectory = true;
              }

              entry.path = entry.path.split('/').filter(function (path) {
                return path && path !== '.';
              }).join('/');
            }

            if (!entry.content) {
              _context5.next = 13;
              break;
            }

            return _context5.delegateYield( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
              var chunker, chunkValidator, file;
              return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                  switch (_context3.prev = _context3.next) {
                    case 0:
                      /**
                       * @type {Chunker}
                       */
                      chunker = void 0;

                      if (typeof options.chunker === 'function') {
                        chunker = options.chunker;
                      } else if (options.chunker === 'rabin') {
                        chunker = require('../chunker/rabin');
                      } else {
                        chunker = require('../chunker/fixed-size');
                      }
                      /**
                       * @type {ChunkValidator}
                       */


                      chunkValidator = void 0;

                      if (typeof options.chunkValidator === 'function') {
                        chunkValidator = options.chunkValidator;
                      } else {
                        chunkValidator = require('./validate-chunks');
                      }
                      /** @type {File} */


                      file = {
                        path: entry.path,
                        mtime: entry.mtime,
                        mode: entry.mode,
                        content: chunker(chunkValidator(contentAsAsyncIterable(entry.content), options), options)
                      };
                      _context3.next = 7;
                      return function () {
                        return fileBuilder(file, block, options);
                      };

                    case 7:
                    case "end":
                      return _context3.stop();
                  }
                }
              }, _callee3);
            })(), "t0", 11);

          case 11:
            _context5.next = 18;
            break;

          case 13:
            if (!entry.path) {
              _context5.next = 17;
              break;
            }

            return _context5.delegateYield( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
              var dir;
              return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1) {
                  switch (_context4.prev = _context4.next) {
                    case 0:
                      /** @type {Directory} */
                      dir = {
                        path: entry.path,
                        mtime: entry.mtime,
                        mode: entry.mode
                      };
                      _context4.next = 3;
                      return function () {
                        return dirBuilder(dir, block, options);
                      };

                    case 3:
                    case "end":
                      return _context4.stop();
                  }
                }
              }, _callee4);
            })(), "t1", 15);

          case 15:
            _context5.next = 18;
            break;

          case 17:
            throw new Error('Import candidate must have content or path or both');

          case 18:
            _iteratorAbruptCompletion = false;
            _context5.next = 4;
            break;

          case 21:
            _context5.next = 27;
            break;

          case 23:
            _context5.prev = 23;
            _context5.t2 = _context5["catch"](2);
            _didIteratorError = true;
            _iteratorError = _context5.t2;

          case 27:
            _context5.prev = 27;
            _context5.prev = 28;

            if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
              _context5.next = 32;
              break;
            }

            _context5.next = 32;
            return _awaitAsyncGenerator(_iterator.return());

          case 32:
            _context5.prev = 32;

            if (!_didIteratorError) {
              _context5.next = 35;
              break;
            }

            throw _iteratorError;

          case 35:
            return _context5.finish(32);

          case 36:
            return _context5.finish(27);

          case 37:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[2, 23, 27, 37], [28,, 32, 36]]);
  }));
  return _dagBuilder.apply(this, arguments);
}

module.exports = dagBuilder;